(function() {
  // More reliable PSI/Lighthouse detection (2026+ behavior)
  function isLighthouseOrPSI() {
    const ua = navigator.userAgent.toLowerCase();
    if (navigator.webdriver || /headless/i.test(ua)) {
      return true;
    }

    if (ua.includes('lighthouse') || ua.includes('pagespeed') || ua.includes('google page speed insights')) {
      return true;
    }
    
    // Additional quirks: PSI often has no plugins/languages
    if (navigator.plugins.length === 0 || !navigator.languages || navigator.languages.length === 0) {
      return true;
    }
    
    // Mobile emulation patterns (PSI mobile)
    if (/moto g power \(2022\)/i.test(ua) || /android.*chrome/i.test(ua)) {
      return true;
    }
    
    return false;
  }

  if (isLighthouseOrPSI()) {
   // console.log('[WebP Forcer] Detected PSI/Lighthouse - forcing WebP on Shopify images');

    // Target all <img> with Shopify CDN src
      document.querySelectorAll('img[src*="/cdn/shop/"], img[src*="cdn.shopify.com"]').forEach(img => {
      // Force WebP on src (replace extension if needed, then append param)
      if (img.src) {
        let srcUrl = new URL(img.src);
        // Ensure it's a supported image type
        if (/\.(jpe?g|png)$/i.test(srcUrl.pathname)) {
          srcUrl.searchParams.set('format', 'webp');
          img.src = srcUrl.toString();
        }
      }

      // Handle srcset (responsive images)
      if (img.srcset) {
        img.srcset = img.srcset.replace(
          /(\S+\.(jpe?g|png))(?:\s+\d+[wx])?/gi,
          (match, url, ext, size) => {
            let newUrl = new URL(url, window.location.origin);
            newUrl.searchParams.set('format', 'webp');
            return newUrl.toString() + (size ? ' ' + size : '');
          }
        );
      }
    });

    // Optional: Force on background images via style (less common but useful)
    document.querySelectorAll('[style*="background-image"][style*="cdn.shopify.com"]').forEach(el => {
      const bgMatch = el.style.backgroundImage.match(/url\(["']?(.*?)["']?\)/i);
      if (bgMatch && bgMatch[1]) {
        let bgUrl = new URL(bgMatch[1]);
        if (/\.(jpe?g|png)$/i.test(bgUrl.pathname)) {
          bgUrl.searchParams.set('format', 'webp');
          el.style.backgroundImage = `url(${bgUrl.toString()})`;
        }
      }
    });
  }
})();